"use client";
import React, { useState, useEffect, useContext } from "react";
import { AppBar, Toolbar, IconButton, Stack, Typography, Avatar, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchForm from "./SearchForm";
import Email from "./Email";
import Notification from "./Notification";
import Profile from "./Profile";
import Tooltip from "@mui/material/Tooltip";
import CurrentDate from "./CurrentDate";

import { getUserData } from "@/utils/userData";
import { userService } from "../../../services/user.service";
import { useThemeMode } from "@/contexts/ThemeContext";

import { useRouter, usePathname } from "next/navigation";

const TopNavbar = ({ toogleActive }) => {
	const { userData } = getUserData();

	const { isDarkMode } = useThemeMode();

	const handleLogout = () => {
		userService.logout();
	};

	if (userData?.admin > 0) {
		return (
			<>
				<AppBar
					color='inherit'
					sx={{
						backgroundColor: isDarkMode ? "#0d1015" : "#fff",
						boxShadow: "0px 4px 20px rgba(47, 143, 232, 0.07)",
						py: "6px",
						mb: "30px",
						position: "sticky",
					}}
					className='topNavbarLight'>
					<Toolbar>
						<Tooltip title='Hide/Show' arrow>
							<IconButton size='sm' edge='start' color='inherit' onClick={toogleActive}>
								<i className='ri-align-left'></i>
							</IconButton>
						</Tooltip>

						{/* Search form */}
						<SearchForm />

						<Typography component='div' sx={{ flexGrow: 1 }}></Typography>

						<Stack direction='row' spacing={2}>
							{/* CurrentDate */}
							<CurrentDate />

							{/* Notification */}
							<Email />

							{/* Notification */}
							<Notification />

							{/* Profile */}
							<Profile />
						</Stack>
					</Toolbar>
				</AppBar>
			</>
		);
	} else {
		const router = useRouter();

		const pathname = usePathname();
		const isHomePage = pathname === "/";

		return (
			<>
				<AppBar
					color='inherit'
					sx={{
						backgroundColor: isDarkMode ? "#0d1015" : "#fff",
						boxShadow: "0px 4px 20px rgba(47, 143, 232, 0.07)",
						py: "6px",
						mb: "30px",
						position: "sticky",
					}}
					className=''>
					<Toolbar>
						{isHomePage ? (
							<Tooltip title={userData?.firstName}>
								<IconButton size='small' sx={{ p: 0 }} className='ml-0'>
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
										}}>
										<Avatar
											src={userData?.avatar}
											alt={userData?.firstName}
											sx={{ width: 45, height: 45 }}
										/>
										<Box
											sx={{
												ml: 1,
												textAlign: "left",
											}}>
											<Typography
												sx={{
													fontSize: "13px",
													color: isDarkMode ? "#fff" : "#000",
													fontWeight: "500",
												}}>
												{userData?.firstName + " " + userData?.lastName}
											</Typography>
                                                       {userData?.cnp && (
                                                            <Typography
                                                                 sx={{
                                                                      fontSize: "12px",
                                                                      color: isDarkMode ? "#fff" : "#000",
                                                                 }}>
                                                                 CNP: {userData?.cnp}
                                                            </Typography>
                                                       )}
										</Box>
									</Box>
								</IconButton>
							</Tooltip>
						) : (
							<IconButton
								onClick={() => router.push("/")}
								sx={{
									backgroundColor: isDarkMode ? "#1e2329" : "#fff",
									color: isDarkMode ? "#fff" : "#000",
									width: 45,
									height: 45,
									border: `1px solid ${isDarkMode ? "#2a3038" : "#e0e0e0"}`,
									boxShadow: isDarkMode
										? "0 2px 8px rgba(0,0,0,0.3)"
										: "0 2px 8px rgba(0,0,0,0.1)",
									"&:hover": {
										backgroundColor: isDarkMode ? "#2a3038" : "#f5f5f5",
										borderColor: isDarkMode ? "#3a4048" : "#d0d0d0",
									},
								}}>
								<ArrowBackIcon />
							</IconButton>
						)}
						<Typography component='div' sx={{ flexGrow: 1 }}></Typography>
						<Stack direction='row' spacing={2}>
							{/* Notification */}
							<Notification />

							<Tooltip title='Deconectare' arrow>
								<i
									className='ri-logout-circle-r-line'
									style={{ fontSize: 26, color: "red", cursor: "pointer" }}
									onClick={handleLogout}></i>
							</Tooltip>
						</Stack>
					</Toolbar>
				</AppBar>
			</>
		);
	}
};

export default TopNavbar;
